// extracted by mini-css-extract-plugin
export var cardHeader = "_fy-0";
export var reorderHandle = "_fy-3";
export var titleArea = "_fy-1";
export var titleAreaWithHandle = "_fy-2";